function isIndexPath(state) {
  var _state_index;
  if (!state.routes) {
    return false;
  }
  var route = getActualLastRoute(state.routes[(_state_index = state.index) !== null && _state_index !== void 0 ? _state_index : state.routes.length - 1]);
  if (route.state) {
    return isIndexPath(route.state);
  }
  if (route.name === "index") {
    return true;
  }
  if (route.params && "screen" in route.params) {
    return route.params.screen === "index";
  }
  if (route.name.match(/.+\/index$/)) {
    return true;
  }
  return false;
}
function getActualLastRoute(routeLike) {
  var _routeLike_state;
  if (routeLike.name[0] === "(" && ((_routeLike_state = routeLike.state) === null || _routeLike_state === void 0 ? void 0 : _routeLike_state.routes)) {
    var _routeLike_state_index;
    var routes = routeLike.state.routes;
    return getActualLastRoute(routes[(_routeLike_state_index = routeLike.state.index) !== null && _routeLike_state_index !== void 0 ? _routeLike_state_index : routes.length - 1]);
  }
  return routeLike;
}
export {
  isIndexPath
};
//# sourceMappingURL=isIndexPath.js.map
